var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"inner-page-loader"},[_c('v-btn',{attrs:{"x-large":"","loading":"","text":"","depressed":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }